module.exports = __webpack_public_path__ + "static/media/fa-brands-400.ed2b8bf1.ttf";